import { createApp } from 'vue'
import blogGrid from './blog-grid.vue';
import {getPropsData} from '../../utils/helper-functions'

export default () => {
  document.querySelectorAll('blog-grid').forEach((el) => {
    const propData = getPropsData(el.closest('section').nextElementSibling);
    createApp(blogGrid, {data:propData}).mount(el);
  })
}